module.exports = __webpack_public_path__ + "img/charging-hub-suggestion-proprietary.87be5053.svg";